import React from 'react';
import Image from 'next/image';
import { MomentumType } from 'legacy/events/types';
import { useTranslation } from 'react-i18next';
import { TFunction } from 'i18next';

interface MomentumChipProps {
  type: MomentumType;
  displayCount: number;
}

const iconMap = {
  [MomentumType.SELLING_FAST_30_MINUTES]: '/img/icons/selling-fast.svg',
  [MomentumType.SELLING_FAST_24_HOURS]: '/img/icons/grabbed-tix.svg',
  [MomentumType.VIEWING_NOW]: '/img/icons/viewing-now.svg',
  [MomentumType.VIEWING_24_HOURS]: '/img/icons/viewed-recently.svg'
};

const getMomentumChipText = (
  type: MomentumType,
  displayCount: number,
  t: TFunction
) => {
  switch (type) {
    case MomentumType.SELLING_FAST_30_MINUTES:
      return t('momentumChips.sellingFast30Minutes', { count: displayCount });
    case MomentumType.SELLING_FAST_24_HOURS:
      return t('momentumChips.sellingFast24Hours', { count: displayCount });
    case MomentumType.VIEWING_NOW:
      return t('momentumChips.viewingNow', { count: displayCount });
    case MomentumType.VIEWING_24_HOURS:
      return t('momentumChips.viewing24Hours', { count: displayCount });
    default:
      return null;
  }
};

const momentumChipStylesMap = {
  [MomentumType.SELLING_FAST_30_MINUTES]:
    'bg-linear-to-r from-[#FFEDEB] to-transparent text-[#60150F]',
  [MomentumType.SELLING_FAST_24_HOURS]:
    'bg-linear-to-r from-[#ECFEFE] to-transparent text-[#103D48]',
  [MomentumType.VIEWING_NOW]:
    'bg-linear-to-r from-[#FFE7324D] to-transparent text-[#684D16]',
  [MomentumType.VIEWING_24_HOURS]:
    'bg-linear-to-r from-[#C8C8C8] to-transparent text-[#333333]'
};

const momentumChipAltTextMap = {
  [MomentumType.SELLING_FAST_30_MINUTES]: 'altSellingFast',
  [MomentumType.SELLING_FAST_24_HOURS]: 'altGrabbedTickets',
  [MomentumType.VIEWING_NOW]: 'altViewingNow',
  [MomentumType.VIEWING_24_HOURS]: 'altViewedRecently'
};

const MomentumChip: React.FC<MomentumChipProps> = ({ type, displayCount }) => {
  const { t } = useTranslation(['common']);
  return (
    <div
      className={`${momentumChipStylesMap[type]} flex items-center gap-2 h-[24px] w-full rounded-md px-2`}
    >
      <Image
        src={iconMap[type]}
        alt={t(momentumChipAltTextMap[type])}
        width={40}
        height={40}
      />
      <span>{getMomentumChipText(type, displayCount, t)}</span>
    </div>
  );
};
export default MomentumChip;
